import * as React from "react";
import './Pick.css';
import '../../components/Typograph.css';
import AppHeader from '../../components/AppHeader';
import AppFooter from "../../components/AppFooter";
import ImageRadioPicker from "../../components/ImageRadioPicker";
import {Luiksluiting} from "../../Model";
import typeFImage from '../../images/sluiting/luiksluitingF.jpg'
import typeAImage from '../../images/sluiting/luiksluitingA.jpg'
import typeDImage from '../../images/sluiting/luiksluitingD.jpg'
import macoImage from '../../images/sluiting/luiksluitingMaco.jpg'
import geenLuiksluitingImage from '../../images/sluiting/geen luiksluiting.jpg'
import oudhollandsImage from '../../images/sluiting/luiksluiting Oudhollands.jpg'
import traditioneelImage from '../../images/sluiting/luiksluiting traditioneel.jpg'
import enkelImage from '../../images/sluiting/enkele luiksluiting.jpg'
import otherImage from '../../images/template/other1.png'
import PropTypes from "prop-types";

ClosingPick.propTypes = {
    handleNextPage: PropTypes.func.isRequired,
    handlePreviousPage: PropTypes.func.isRequired,
    handlePageChange: PropTypes.func.isRequired,
    allValues: PropTypes.object.isRequired,
}

export default function ClosingPick(props) {
    const currentValue = props.allValues.ClosingPick;

    return (
        <div className="page">
            <AppHeader title="Luiksluiting"/>

            <div className="page-middle">
                <h1 className="pick-title">Welke luiksluiting moet deze situatie krijgen?</h1>
                <h4>Het is mogelijk dat uw voorkeur niet altijd te combineren is met uw aanvraag. In dat geval zullen wij u een passend alternatief advies geven.</h4>
                <div className="pick-body scrollable">
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={Luiksluiting.TYPE_F}
                                      image={typeFImage}
                                      hintText={"Luiksluiting type F"}/>
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={Luiksluiting.TYPE_A}
                                      image={typeAImage}
                                      hintText={"Luiksluiting type A"}/>
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={Luiksluiting.TYPE_D}
                                      image={typeDImage}
                                      hintText={"Luiksluiting type D"}/>
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={Luiksluiting.OUDHOLLANDS}
                                      image={oudhollandsImage}
                                      hintText={"luiksluiting Oudhollands"}/>
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={Luiksluiting.TRADITIONEEL}
                                      image={traditioneelImage}
                                      hintText={"luiksluiting traditioneel"}/>
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={Luiksluiting.ENKEL}
                                      image={enkelImage}
                                      hintText={"enkele luiksluiting, alleen toe te passen bij enkele luiken kozijnmontage"}/>
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={Luiksluiting.MACO}
                                      image={macoImage}
                                      hintText={"Luiksluiting van Maco"}/>
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={Luiksluiting.NO_CLOSING}
                                      image={geenLuiksluitingImage}/>
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={{value: Luiksluiting.OTHER, text: ""}}
                                      child
                                      image={otherImage}/>
                </div>
            </div>
            <AppFooter onNext={props.handleNextPage}
                       onPrevious={props.handlePreviousPage}
                       enableNext={currentValue}/>
        </div>
    );
}